import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';

export const resolveLogDimensions = (data, dimensions) => {
  const dataClone = cloneDeep(data);

  ['target.dimension', 'target.secondaryDimension'].forEach(path => {
    const dimensionId = get(dataClone, path);
    if (dimensionId) {
      const dimension = dimensions.find(({ id }) => id === dimensionId);
      if (!dimension) {
        throw new Error(`Unknown dimension ${dimensionId}`);
      }
      set(dataClone, path, dimension.trackerId);
    }
  });

  return dataClone;
};
